var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var Link = require('react-router').Link;
var Loader = require('react-loader');
var PropTypes = require('prop-types');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var utils = require('../../../utils/utils');
var SubscribeForm = require('./subscribeForm.jsx');
var PartnerLogos = require('../../components/partnerLogos.jsx');

var Home = createReactClass({
    mixins: [PureRenderMixin],

    getInitialState: function(){
        return {
            isUserPromisSurveyAlreadyTaked: false
        };
    },

    componentDidMount: function(){
        this.updateIsUserPromisSurveyAlreadyTakedState(this.props.latestScore);

        if(this.props.auth.token){
            this.props.fetchLatestScore(this.props.auth.token);
        }
    },

    componentWillReceiveProps: function(nextProps){
        if(nextProps.auth.user.id && nextProps.auth.user.id !== this.props.auth.user.id){
            this.props.fetchLatestScore(this.props.auth.token);
        }

        if(nextProps.latestScore.submissionId && nextProps.latestScore.submissionId !== this.props.latestScore.submissionId){
            this.updateIsUserPromisSurveyAlreadyTakedState(nextProps.latestScore);
        }

        if (
          !nextProps.auth.token &&
          !nextProps.practice.isFetching &&
          Object.keys(nextProps.practice.data).length !== 0
        ) {
          this.context.router.push('/sign-up');
        }
    },

    updateIsUserPromisSurveyAlreadyTakedState: function(latestScore){
        this.setState({
            isUserPromisSurveyAlreadyTaked: utils.isSurveyCompleted(latestScore)
        });
    },

	handleSubscribe: function(email) {
		this.props.signUp(email);
    },

    handleClickTracking: function(e) {
        var label = 'Home Page';
        var action = 'Click';
        this.props.recordDownloadClick(action, label);
    },

    handleSurveyClick: function(event){
        var target = event.target;
        var promisPathname = '/dashboard/surveys/promis';

        if(event.target.getAttribute('href') !== promisPathname){
            this.props.setLoginRedirectUrl(promisPathname);
        }

        if(target.innerText === 'Track again tomorrow'){
            this.props.showModal('MODAL_TYPE_PROMIS');
        }
        this.props.recordSurveyButtonClicked(target.innerText);
    },

    render: function(){
        if (this.props.practice.isFetching) {
            return <Loader />;
        }

        return (
			<div className="content fadeIn animated duration-750 delay-600">
          <Helmet
              title="Stomach, Gastrointestinal (GI), and Digestive Health"
              meta={[{
                  name: 'description',
                  content: 'Learn more about your digestive health. Track digestive disorders and treat your Gi symptoms with MyGiHealth. Download the App now.'
              }]}
          />
			    <div id="hero-container">
			        <section id="hero">
			            <div className="row">
			                <div className="large-8 small-12 column">
			                    <div className="row fadeIn ease-in-out duration-1500 delay-500 animated" id="headline">
			                        <div className="column">
			                            <h1 className="">Use MyGiHealth to track, understand & improve your Gi symptoms</h1>
			                        </div>
			                    </div>
			                    <div className="description-wrapper row">
			                        <div className="large-7 small-12 column">
			                            <ul className="checklist fadeIn ease-in-out duration-2000 delay-1000 animated">
                                            <li>Improves doctor patient communication</li>
			                                <li>Educational Prescription tailored to your symptoms</li>
			                                <li>Prepare for & get more out of your doctor visits</li>
			                                <li>Scientifically-tested and validated tools</li>
			                                <li>Uncover the emotional connection with MyQoL</li>
			                                <li>Designed by industry leading Gi physicians</li>
			                            </ul>
                                        <div className="partners fadeIn ease-in-out duration-2000 delay-1200 animated">
			                                <PartnerLogos />
			                            </div>
			                        </div>
			                    </div>
			                </div>
			                <div className="large-4 small-12 column end">
                                <div className="action-wrapper row collapse">
                                    <div className="small-12 column">
                                        <div className="iphone-wrapper">
                                            <div id="iphone" className="iphone fadeInRight ease-in-out duration-1500 delay-1500 animated"></div>
                                        </div>
                                    </div>
                                    <div className="small-12 large-pull-10 column">
                                        <div className="button-container">
                                            {this.state.isUserPromisSurveyAlreadyTaked
                                                ? <a className="button secondary" onClick={this.handleSurveyClick}>Track again tomorrow</a>
                                                : <Link to={this.props.auth.token ? '/dashboard/surveys/promis' : '/register'} className="button success" onClick={this.handleSurveyClick}>Start tracking your symptoms</Link>
                                            }
    			                            <a className="download-app" href="http://get.mygihealth.io/downloadtheapp" onClick={this.handleClickTracking}>
                                                <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/app-store-badge.png" alt="Download on the App Store" id="app-store-badge" />
    			                            </a>
			                            </div>
                                    </div>
                                </div>
			                </div>
			            </div>
			        </section>
			    </div>
			    <div id="secondary">
			        <section id="education">
			            <div className="row">
			                <div className="large-5 small-12 column">
			                    <div id="body">
			                        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/male-transparent.png" alt="MyGiHealth Learning Center" title="MyGiHealth Learning Center" />
			                    </div>
			                </div>
			                <div className="headline large-5 small-12 column end">
			                    <h2>Understanding your symptoms is the first step toward feeling better.</h2>
			                    <p>The Learning Center empowers you with answers to the important questions you have about your Gi disorder.</p>
                                <p><Link to="/education" className="link button">Visit the Gi Learning Center</Link></p>
			                </div>
			            </div>
			        </section>
			    </div>
                <div className="usecases-wrapper">
                    <section id="usecases">
                        <div className="row collapse">
                            <div className="medium-6 column">
                                <div className="personal-use-case use-case">
                                    <h3>Personal Use <span>With Your Mobile Device</span></h3>
                                    <p className="description">Use our academically researched and validated tools to gain control over your symptoms. Assess, track, and compare your symptoms to benchmarks, and learn more about them from an Education Prescription&copy;.</p>
                                    <p className="text-center"><Link className="button success" to="/app">Personal Use</Link></p>
                                </div>
                            </div>
                            <div className="medium-6 column end">
                                <div className="clinical-use-case use-case">
                                    <h3>Clinical Use <span>Connecting Healthcare Professionals To Patients</span></h3>
                                    <p className="description">Working with experts in patient communication and computing technology, doctors at Cedars-Sinai, the University of Michigan and UCLA have re-engineered the role of technology in clinical practice.</p>
                                    <p className="text-center"><Link className="button" to="/clinical-use">Clinical Use</Link></p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
			    <div id="tertiary">
			        <section id="newsletter" name="newsletter">
			            <div className="row">
			                <div className="headline large-5 small-12 large-offset-1 column">
								<p>Sign up for email updates and get early access to our latest products, features & tools!</p>
			                </div>
			                <div className="large-6 small-12 column end">
			                    <div id="sign-up">
		                        	<SubscribeForm
                                        newsletter={this.props.newsletter}
                                        subscribe={this.handleSubscribe}
                                        clearError={this.props.clearNewsletterError} />
		                            <p>Your email is safe with us!  We will never give your information to a third party. You can expect about one email per month.</p>
			                    </div>
			                </div>
			            </div>
			        </section>
			    </div>
                <div className="about-wrapper">
			        <section id="about">
			            <div className="row">
			                <div className="medium-7 medium-centered small-12 column">
			                    <h2>About MyGiHealth</h2>
                                <p>My Total Health was founded to enable patients to monitor, manage, and understand their symptoms for a range of conditions. MyGiHealth is the first of a pipeline of novel health applications created by the team.</p>
                                <p className="text-center"><Link className="button secondary" to="/about">Meet the Team</Link></p>
                            </div>
			            </div>
			        </section>
			    </div>
			    <div id="preload">
			        <img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/mygihealth-app-dashboard-v3.png" alt="" />
			    </div>
			</div>
        )
    }
});

Home.contextTypes = {
  router: PropTypes.object.isRequired
};

module.exports = Home;



// WEBPACK FOOTER //
// ./src/common/routes/home/components/home.jsx